import { primary } from "./palette"

const shadow = {
  button: `0 1px 6px hsla(0,0%,0%,0.25)`,
  card: `0 3px 4px hsla(0,0%,0%,0.1)`,
  select: `0 1px 2px hsla(0,0%,0%,0.025), 0 2px 6px hsla(0,0%,0%,0.035)`,
  popover: `0 1px 16px ${primary._75}, 0 2px 30px hsla(0,0%,0%,0)`,
}
export default shadow
